module.exports = __webpack_public_path__ + "static/a16n-logo-1f915a0266fcc6869a528421f59f29af.svg";